import SampleTypeModel from "@/models/lab/SampleTypeModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

/**
 * SampleType collection
 */
export default class SampleTypeCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return SampleTypeModel;
  }

  publicRoutes() {
    let model = (new (this.model())());
    return {
      fetch: process.env.VUE_APP_LAB_REPOSITORY_URL + '/api/v1/public/' + model.modelName(),
    }
  }

  /**
   * default collection configuration.
   */
  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddAsc('position');
    return CollectionFilter;
  }

}
